// Claude on a shot's own page (board "Claude: oben auf der Seite eines Bezugs", Strava's pattern): the card right under
// the shot's figures and rating, before the curve; the old button at the end of the page is gone. Nothing shows without
// a key or before something was asked (a sour or bitter rating asks). The card itself is ClaudeBox.
import type { ShotItem } from '@brewcore/app-contract';
import { Card, Collapse } from '../components/index.js';
import { ClaudeBox, useClaudeCard } from './ClaudeBox.js';

export function ClaudeShot({ shot }: { shot: ShotItem }) {
  const c = useClaudeCard(shot, 'shot');
  const shown = !!c && c.card.state !== 'none';
  return (
    <Collapse open={shown}>
      {c && shown && (
        <Card className="tab-card ai-shot" data-testid="claude-shot-card">
          <ClaudeBox c={c} />
        </Card>
      )}
    </Collapse>
  );
}
